import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Pagination from '@material-ui/lab/Pagination';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LaunchIcon from '@material-ui/icons/Launch';
import EditIcon from '@material-ui/icons/Edit';

import EnhancedTableToolbar from "./EnhancedTableToolbar";
import EnhancedTableHead from "./EnhancedTableHead";



import { inject, observer } from 'mobx-react';
import { Framework } from '@flint/framework';

const handleBackClick = () => {
    window.history.back();
};

const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),
    },
    paper: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableHeading: {
        fontSize: "20px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "29px",
        color: "#000000",
        
    },
    tableRow: {
        fontSize: "17px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        lineHeight: "30px",
        color: "#000000",
        textDecoration:"none",
    },
    paginationRow: {
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "center",
    },
    pointer:{
        cursor:"pointer",
    },
    backIcon: {
        height: "28px",
        width: "28px",
    }
}));

const TopicTable = ({ TopicListStore }) => {
    
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('topicTitle');
    const [page, setPage] = React.useState(0);
    const [rows, setRows] = React.useState([]);

    const rowsPerPage = 10;

    const [searchTerm, setSearchTerm] = React.useState('');

    React.useEffect(() => {
        document.title = "Topic List Page";
        Framework.sendEvent("FETCHING_TOPIC_LIST", `${window.location.pathname.split("/")[2]}`);
        setRows(TopicListStore.topics);
    }, []);

    const handleSearchTopic = (event) => {
        setSearchTerm(event.target.value);
    }

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const filteredRow = rows.filter(topic=>topic.topicTitle.toLowerCase().includes(searchTerm.toLowerCase()));
        setRows(filteredRow);
        setPage(0);
    }

    const clearSearchFilter = () => {
        setSearchTerm("");
        setRows(TopicListStore.topics);
        setPage(0);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
   
    const handleEditTopic = (id) => {
        Framework.redirect(`/edit-topic/${id}`);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1);
    };



    return (
        <>
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <Tooltip title="Go back to EPub Table">
                        <IconButton onClick={handleBackClick}>
                            <ArrowBackIcon className={classes.backIcon} />
                        </IconButton>
                    </Tooltip>
                    <EnhancedTableToolbar searchTerm={searchTerm} handleSearchTopic={handleSearchTopic} handleSearchSubmit={handleSearchSubmit} clearSearchFilter={clearSearchFilter} />
                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            />
                            <TableBody>
                                {stableSort(rows, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={row.id}
                                                className={classes.tableRow}
                                            >
                                                <TableCell component="th" id={labelId} scope="row" className={classes.tableRow}>{row.topicTitle}</TableCell>
                                                <TableCell align="center" className={classes.tableRow}><a className={classes.tableRow} rel="noopener noreferrer" target="_blank" href={`${process.env.REACT_APP_FRONTEND_URL}/topic/${row.id}`}><LaunchIcon color="primary"/></a></TableCell>
                                                <TableCell align="center" className={`${classes.tableRow} ${classes.pointer}`} onClick={() => handleEditTopic(row.id)}><EditIcon color="primary"/></TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Pagination count={Math.ceil(rows.length / rowsPerPage)} onChange={handleChangePage} shape="rounded" className={classes.paginationRow} />
                </Paper>
            </div>
        </>
    );
}

export default inject('TopicListStore')(observer(TopicTable));